import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Home from './../containers/Home'
import Agency from './../containers/Agency'
//import Team from './../containers/Team'
import Work from './../containers/Work'
import MajorCase from './../containers/MajorCase'
import Contact from './../containers/Contact'
import Legal from './../containers/Legal'
import Page404 from './../containers/Page404'
import Page30yo from './../containers/Page30yo'

/**
  * @class Router
  * Link between routes and components
  * These "big" components are considered as "containers"
  * If a route is not defined, Page404 by default
*/
//const domain = process.env.REACT_APP_HOME

class Router extends React.Component {
  render() {
    return(
      <Switch>
        <Route exact path={"/"} component={Home}/>
        <Route exact path={"/agence"} component={Agency} />
        <Route path={"/agence/:id"} component={Agency} />
        <Route exact path={"/work"} component={Work} />
        <Route exact path={"/contact"} component={Contact} />
        <Route exact path={"/mentions-legales"} component={Legal} />
        <Route exact path="/cas-client-:url" component={MajorCase}/>
        <Route exact path="/30-ans" component={Page30yo}/>
        <Route exact path="/altavia-cosmic-a-30-ans" component={Page30yo}/>
        <Route component={Page404}/>
      </Switch>
    )
  }
}
/*
  TODO
  Dynamic urls for minor cases details (= json wp ?)
  URL for major cases details
  Dynamic urls for all competences (= json wp ?)
*/

export default Router



// WEBPACK FOOTER //
// ./src/components/Router.jsx